module.exports = {"apiBaseUrl":"http://192.168.99.100:3000/","flinkLibraryUrl":"http://192.168.99.100:3000/client.js"}


//////////////////
// WEBPACK FOOTER
// ./src/lib/config/config.localdev.json
// module id = NrRE
// module chunks = 1